export enum ELocalStorage {
  subscriptionAttentionClosed = "subscriptionAttentionClosed",
}
